import { useState, useEffect } from "react";
import { useCalendar } from "./useCalendar";

export function useCalendarMultiple(): boolean {
  const context = useCalendar();
  const [value, setValue] = useState<boolean>(false);
  useEffect(() => {
    setValue(context.multiple);
  }, [context]);
  return value;
}
